/* =============================================================================
   Still Light · Homepage behaviour (vanilla, no theme dependencies)
   - SiteNav mobile drawer
   - Hero film play / sound toggles
   - HaloStage device carousel + annotation draw-on-view + halo parallax
   - SpectrumScroll scroll-pinned wavelength story
   - StoryRail autoplay-in-view + Instagram-style viewer
   ============================================================================= */
(function () {
  'use strict';
  if (window.__slHomeInit) return; window.__slHomeInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var safePlay = function (v) { if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); };

  /* Generic "in view" helper: fires once, falls back to end state if IO is missing. */
  function onInView(el, cb, threshold) {
    if (!el) return;
    if (reduced || !('IntersectionObserver' in window) || document.hidden) { cb(); return; }
    var r = el.getBoundingClientRect();
    if (r.bottom > 0 && r.top < window.innerHeight) { cb(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cb(); io.disconnect(); } }); }, { threshold: threshold || 0.25 });
    io.observe(el);
  }

  /* ---- nav drawer ------------------------------------------------------ */
  (function nav() {
    var drawer = $('[data-sl-drawer]'); if (!drawer) return;
    var open = function () { drawer.setAttribute('data-open', ''); document.body.classList.add('sl-lock'); var f = $('[data-sl-drawer-close]', drawer); if (f) f.focus(); };
    var close = function () { drawer.removeAttribute('data-open'); document.body.classList.remove('sl-lock'); };
    $$('[data-sl-menu]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-sl-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', close); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close(); });
  })();

  /* ---- hero film ------------------------------------------------------- */
  (function hero() {
    var v = $('[data-sl-hero-video]'); if (!v) return;
    var playBtn = $('[data-sl-hero-play]'), soundBtn = $('[data-sl-hero-sound]');
    var playing = true, sound = false;
    var sync = function () {
      v.muted = !sound; v.loop = true; v.playsInline = true;
      if (playing) safePlay(v); else v.pause();
      if (playBtn) playBtn.textContent = playing ? 'Pause' : 'Play';
      if (soundBtn) soundBtn.textContent = sound ? 'Sound off' : 'Sound on';
    };
    if (playBtn) playBtn.addEventListener('click', function () { playing = !playing; sync(); });
    if (soundBtn) soundBtn.addEventListener('click', function () { sound = !sound; sync(); });
    sync();
  })();

  /* ---- halo (draw on view + parallax) ---------------------------------- */
  (function halos() {
    $$('[data-sl-halo]').forEach(function (h) {
      if (!reduced && h.hasAttribute('data-draw')) { h.classList.add('is-drawing'); onInView(h, function () { h.classList.add('is-drawing'); }); }
      if (h.hasAttribute('data-parallax') && !reduced) {
        var svg = $('svg', h), tick = function () {
          var b = h.getBoundingClientRect(); var c = (b.top + b.height / 2) - window.innerHeight / 2;
          var dy = Math.max(-4, Math.min(4, -c / 120)); svg.style.transform = 'translateY(' + dy + 'px)';
        };
        tick(); window.addEventListener('scroll', tick, { passive: true });
      }
    });
    /* annotations draw when they scroll into view */
    $$('.sl-ann').forEach(function (a) { onInView(a, function () { a.classList.add('is-on'); }); });
  })();

  /* ---- halo stage carousel -------------------------------------------- */
  (function stage() {
    var root = $('[data-sl-stage]'); if (!root) return;
    var imgs = $$('.sl-stage__img img', root), panels = $$('.sl-stage__panel', root), tabs = $$('[role="tab"]', root);
    var cols = { left: $('.sl-stage__col--left', root), right: $('.sl-stage__col--right', root) };
    var facts = []; try { facts = JSON.parse($('[data-sl-stage-facts]', root).textContent); } catch (e) {}
    var i = parseInt(root.getAttribute('data-start') || '0', 10) || 0, n = imgs.length;
    var renderAnn = function (side, list) {
      var col = cols[side]; if (!col) return; col.innerHTML = '';
      (list || []).forEach(function (a) {
        var el = document.createElement('div'); el.className = 'sl-ann sl-ann--' + side;
        var rule = '<div class="sl-ann__rule"><div class="sl-ann__line"></div><div class="sl-ann__dot"></div></div>';
        var text = '<div class="sl-ann__text"><div class="sl-ann__stat">' + a.stat + '</div><div class="sl-ann__label">' + a.lines.map(function (l) { return '<span>' + l + '</span>'; }).join('') + '</div></div>';
        el.innerHTML = side === 'left' ? text + rule : rule + text;
        col.appendChild(el);
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-on'); }); });
      });
    };
    var go = function (k) {
      i = ((k % n) + n) % n;
      imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      if (facts[i]) { renderAnn('left', facts[i].left); renderAnn('right', facts[i].right); }
    };
    $$('[data-sl-stage-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    $$('[data-sl-stage-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
    tabs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    go(i);
  })();

  /* ---- spectrum scroll ------------------------------------------------- */
  (function spectrum() {
    var root = $('[data-sl-spectrum]'); if (!root) return;
    var POS = [3.5, 28, 53.5, 100];
    var imgs = $$('.sl-spectrum__frame img', root), panels = $$('.sl-spectrum__panel', root), stops = $$('.sl-spectrum__stop', root), ticks = $$('.sl-spectrum__tick', root);
    var head = $('.sl-spectrum__playhead', root), n = imgs.length || 1, cur = -1;
    var apply = function (step, x) {
      if (step !== cur) {
        cur = step;
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === step); });
        panels.forEach(function (p, j) { p.classList.toggle('is-active', j === step); p.setAttribute('aria-hidden', j === step ? 'false' : 'true'); });
        stops.forEach(function (s, j) { s.setAttribute('aria-pressed', j === step ? 'true' : 'false'); });
        ticks.forEach(function (t, j) { t.classList.toggle('is-active', j === step); });
        root.classList.toggle('is-end', step === n - 1);
      }
      if (head) head.style.left = x + '%';
    };
    var tick = function () {
      var r = root.getBoundingClientRect(), vh = window.innerHeight, range = r.height - vh;
      var p = range > 0 ? Math.min(1, Math.max(0, -r.top / range)) : 0;
      var u = p * n, step = Math.min(n - 1, Math.floor(u)), f = u - step;
      var P = imgs.map(function (_, j) { return POS[Math.min(j, POS.length - 1)]; });
      var x = P[step]; if (step < n - 1 && f > 0.5) x = P[step] + (P[step + 1] - P[step]) * ((f - 0.5) * 2);
      root.classList.toggle('is-short', vh < (window.innerWidth < 1100 ? 780 : 680));
      apply(step, Math.round(x * 4) / 4);
    };
    stops.forEach(function (s, j) {
      s.addEventListener('click', function () {
        var r = root.getBoundingClientRect(), range = r.height - window.innerHeight;
        window.scrollTo({ top: window.scrollY + r.top + (j / n) * range + 2, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
    tick(); window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick);
  })();

  /* ---- story rail ------------------------------------------------------ */
  (function stories() {
    var root = $('[data-sl-stories]'); if (!root) return;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var tiles = $$('.sl-rail__tile', root), vids = $$('video[data-story]', root);
    var viewer = $('[data-sl-viewer]'); if (!viewer) return;
    var vv = $('video', viewer), bars = $$('.sl-viewer__bars span i', viewer), cap = $('.sl-viewer__caption', viewer), cnt = $('.sl-viewer__count', viewer), soundBtn = $('[data-sl-viewer-sound]', viewer);
    var stories = []; try { stories = JSON.parse($('[data-sl-stories-data]', root).textContent); } catch (e) {}
    var open = -1, sound = true;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting && autoplay && open < 0) { v.muted = true; safePlay(v); } else v.pause(); });
      }, { threshold: 0.5 });
      vids.forEach(function (v) { io.observe(v); });
    }

    var setBars = function (prog) { bars.forEach(function (b, j) { b.style.width = j < open ? '100%' : j === open ? Math.round(prog * 100) + '%' : '0'; }); };
    var show = function (k) {
      var s = stories[k]; if (!s) return;
      open = k; vv.src = s.src; vv.poster = s.poster || ''; vv.muted = !sound;
      if (cap) cap.textContent = s.caption || ''; if (cnt) cnt.textContent = (k + 1) + ' of ' + stories.length;
      setBars(0);
      try { vv.currentTime = 0; } catch (e) {}
      var p = vv.play(); if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') { vv.muted = true; sound = false; syncSound(); safePlay(vv); } });
    };
    var syncSound = function () { if (soundBtn) soundBtn.textContent = sound ? 'Sound off' : 'Sound on'; vv.muted = !sound; };
    var closeViewer = function () { open = -1; vv.pause(); vv.removeAttribute('src'); vv.load(); viewer.removeAttribute('data-open'); document.body.classList.remove('sl-lock'); vids.forEach(function (v) { if (autoplay) safePlay(v); }); };
    var openViewer = function (k) { viewer.setAttribute('data-open', ''); document.body.classList.add('sl-lock'); vids.forEach(function (v) { v.pause(); }); show(k); var c = $('[data-sl-viewer-close]', viewer); if (c) c.focus(); };
    var next = function () { if (open >= stories.length - 1) closeViewer(); else show(open + 1); };
    var prev = function () { show(Math.max(0, open - 1)); };

    tiles.forEach(function (t, j) { t.addEventListener('click', function () { openViewer(j); }); });
    vv.addEventListener('ended', next);
    vv.addEventListener('timeupdate', function () { if (vv.duration) setBars(vv.currentTime / vv.duration); });
    $$('[data-sl-viewer-close]', viewer).forEach(function (b) { b.addEventListener('click', closeViewer); });
    $$('[data-sl-viewer-next]', viewer).forEach(function (b) { b.addEventListener('click', next); });
    $$('[data-sl-viewer-prev]', viewer).forEach(function (b) { b.addEventListener('click', prev); });
    if (soundBtn) soundBtn.addEventListener('click', function () { sound = !sound; syncSound(); });
    window.addEventListener('keydown', function (e) {
      if (open < 0) return;
      if (e.key === 'Escape') closeViewer(); else if (e.key === 'ArrowRight') next(); else if (e.key === 'ArrowLeft') prev();
    });
    syncSound();
  })();
})();
